import { Action, createActions } from 'redux-actions';
import { Location } from '../../../LocationAutocomplete/types';

export const SET_RECENT_SEARCHES = 'SET_RECENT_SEARCHES';
export const ADD_RECENT_SEARCH = 'ADD_RECENT_SEARCH';

export type RecentSearchesAction = Action<Location[]>;
export type AddRecentSearchAction = Action<Location>;

export const { setRecentSearches, addRecentSearch } = createActions({
	[SET_RECENT_SEARCHES]: (locations: Location[]) => locations,
	[ADD_RECENT_SEARCH]: (location: Location) => location
});
